export default function TableSorter() {
    

    (function () {
        // Инициализация для всех найденных .js-table-sort (чтобы поддерживать несколько таблиц)
        function initAll() {
            document.querySelectorAll('.js-table-sort').forEach(headEl => {
                const tableEl = headEl.closest('.page-table__table') || headEl.parentElement;
                if (!tableEl) return;
                if (tableEl._tableSorterInitialized) return;
                tableEl._tableSorterInitialized = true;
                createSorter(tableEl);
            });
        }

        function createSorter(tableEl) {
            // делегируем клики на сам контейнер — это выживает при перерендерах заголовка
            function onClick(e) {
                const cell = e.target.closest('.page-table__row_head > div');
                if (!cell || !tableEl.contains(cell)) return;
                if (!cell.textContent.trim()) return; // пропускаем пустые колонки (аватар и т.п.)
                const head = tableEl.querySelector('.page-table__row_head');
                if (!head) return;
                const idx = Array.prototype.indexOf.call(head.children, cell);
                if (idx < 0) return;
                sortByColumn(tableEl, idx);
            }
            tableEl.addEventListener('click', onClick);

            // наблюдаем за изменениями внутри контейнера (перезапись строк/хеда)
            const observer = new MutationObserver(() => {
                // ничего сложного здесь делать не нужно — обработчик на контейнере всё ещё ловит клики.
                // но можно восстановить индикаторы сортировки если нужно:
                const storedCol = tableEl.dataset.sortCol;
                const storedOrder = tableEl.dataset.sortOrder;
                if (storedCol !== undefined) {
                    updateHeaderIndicators(tableEl, parseInt(storedCol, 10), storedOrder);
                }
            });
            observer.observe(tableEl, { childList: true, subtree: true });

            // Сортировка по колонке
            function sortByColumn(tableEl, idx) {
                const rows = Array.from(tableEl.querySelectorAll('.page-table__row'))
                    .filter(r => !r.classList.contains('page-table__row_head'));
                if (!rows.length) return;

                const prevCol = tableEl.dataset.sortCol;
                const prevOrder = tableEl.dataset.sortOrder || 'desc';
                const order = (String(prevCol) === String(idx) && prevOrder === 'desc') ? 'asc' : 'desc';
                tableEl.dataset.sortCol = idx;
                tableEl.dataset.sortOrder = order;

                function getValue(row) {
                    const cell = row.children[idx];
                    if (!cell) return { type: 'string', v: '' };
                    const data = cell.getAttribute('data-sort-value');
                    const text = (data !== null ? data : cell.textContent).trim();

                    // Вытаскиваем лидирующее число (для "9 (0)", "2560", "110" и т.п.)
                    const numMatch = text.match(/^-?\d+(\.\d+)?/);
                    if (numMatch) return { type: 'number', v: parseFloat(numMatch[0]) };
                    return { type: 'string', v: text.toLowerCase() };
                }

                rows.sort((a, b) => {
                    const A = getValue(a);
                    const B = getValue(b);
                    if (A.type === 'number' && B.type === 'number') {
                        return order === 'asc' ? A.v - B.v : B.v - A.v;
                    }
                    if (A.v === B.v) return 0;
                    return order === 'asc' ? String(A.v).localeCompare(String(B.v)) : String(B.v).localeCompare(String(A.v));
                });

                // Вставляем строки обратно сразу после хэдера (чтобы хед остался сверху)
                const head = tableEl.querySelector('.page-table__row_head');
                if (head) {
                    rows.forEach(r => tableEl.appendChild(r));
                    // после appendChild порядок будет: head + отсортированные элементы (append к концу)
                    // (appendChild корректно перемещает уже موجودие узлы)
                } else {
                    rows.forEach(r => tableEl.appendChild(r));
                }

                updateHeaderIndicators(tableEl, idx, order);
            }

            function updateHeaderIndicators(tableEl, idx, order) {
                const head = tableEl.querySelector('.page-table__row_head');
                if (!head) return;
                Array.from(head.children).forEach((cell, i) => {
                    cell.classList.remove('sort-asc', 'sort-desc');
                    if (i === idx) cell.classList.add(order === 'asc' ? 'sort-asc' : 'sort-desc');
                });
            }

            // если таблица уже была отсортирована до и затем перерисована, попытка восстановить индикаторы:
            const storedCol = tableEl.dataset.sortCol;
            if (storedCol !== undefined) {
                updateHeaderIndicators(tableEl, parseInt(storedCol, 10), tableEl.dataset.sortOrder || 'desc');
            }

            // возвращаем объект для возможности clean-up (не обязательно)
            return { destroy() { observer.disconnect(); tableEl.removeEventListener('click', onClick); } };
        }

        // старт
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initAll);
        } else {
            initAll();
        }
    })();

}